module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/layout.component.scss
// module id = ./src/app/containers/layout/layout.component.scss
// module chunks = main